import { useEffect } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController, setMiniSidenav } from "context";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/**
 * PageLayout - A consistent layout wrapper for all authenticated pages
 * This ensures consistent spacing with the sidenav
 */
function PageLayout({ children, title }) {
  const theme = useTheme();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;

  // Check if screen is medium or smaller (below 960px)
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  // Automatically collapse sidenav on medium screens
  useEffect(() => {
    if (isMediumScreen && !miniSidenav) {
      setMiniSidenav(dispatch, true);
    }
  }, [isMediumScreen, dispatch, miniSidenav]);

  // Set page title if provided
  useEffect(() => {
    if (title) {
      document.title = `${title} - NanoTech NetComs AdminZone`;
    }
  }, [title]);

  // The sidebar width when expanded and minimized
  const SIDENAV_WIDTH = "250px";
  const MINI_SIDENAV_WIDTH = "80px";

  return (
    <MDBox
      sx={{
        flex: 1,
        position: "relative",
        mt: { xs: 4, md: 2 },
        ml: { xs: 0, md: 2 },
        width: "100%",
        overflow: "hidden",
      }}
    >
      <DashboardNavbar />
      <MDBox
        sx={{
          p: 3,
          flex: 1,
          position: "relative",
          mt: { xs: 4, md: 2 },
          ml: { xs: 0, md: 2 }, // Add left margin for better spacing from sidebar
          zIndex: 2,
          backgroundColor: "background.default",
          overflow: "auto", // Add scrolling for content if needed
          maxWidth: "100%", // Ensure content doesn't overflow
        }}
      >
        {children}
      </MDBox>
      <Footer
        sx={{
          position: "relative",
          zIndex: 2,
          backgroundColor: "background.default",
          width: "100%",
        }}
      />
    </MDBox>
  );
}

// Add PropTypes validation
PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

// Add default props
PageLayout.defaultProps = {
  title: "AdminZone",
};

export default PageLayout;
